export const ApiBasePath: string = process.env.REACT_APP_API_URL as string;
export const RefreshInterval: number = 60000;

// Custom field scope
export const transactionField: number = 0;
export const ticketField: number = 1;

// Field validation messages
export const requiredField: string = "Empleneu aquest camp per continuar.";
export const emailFormat: string = "Comproveu que el correu electrònic és correcte.";